import { OnboardingFormFields } from '@Types/index.ts';
import { ControllerWrapper } from '@Hooks/index';
import { LiliDropdownItem, LiliTextInput } from '@lili/lili-frontend-common';
import { useTranslation } from 'react-i18next';
import { getRouteOrdinal, RoutesMap } from '@Router/router.types';
import { normalizeInputSpacesOnBlur, normalizeInputSpacesOnChange } from '@Services/utils/utils.ts';
import { Line1Input } from '@Components/inputs/Line1';
import { AddressStateInput } from '@Components/inputs/AddressStateDropDown';
import { ZipInput } from '@Components/inputs/ZipAddress';

export interface IHomeAddressForm {
  [OnboardingFormFields.LINE1]: string;
  [OnboardingFormFields.APARTMENT]: string;
  [OnboardingFormFields.CITY]: string;
  [OnboardingFormFields.STATE]: LiliDropdownItem | null;
  [OnboardingFormFields.ZIP]: string;
}

export interface IHomeAddressFormProps {
  disabled: boolean;
}

export const HomeAddressForm = ({ disabled }: IHomeAddressFormProps) => {
  const { t } = useTranslation();
  const baseTabIndex = getRouteOrdinal(RoutesMap.HOME_ADDRESS);

  return (
    <>
      <Line1Input disabled={disabled} tabIndex={baseTabIndex} />

      <div className='flex flex-col items-start   w-full'>
        <div className='w-full '>
          <ControllerWrapper name={OnboardingFormFields.APARTMENT}>
            {({ value, onBlur, onChange, error }) => (
              <LiliTextInput
                value={value}
                onBlur={onBlur}
                onChange={onChange}
                id={OnboardingFormFields.APARTMENT}
                title={t('pages.homeAddress.lineTwoFieldTitle')}
                errorMessage={error?.message}
                tabIndex={baseTabIndex + 1}
                disabled={disabled}
              />
            )}
          </ControllerWrapper>
        </div>

        <div className='w-full '>
          <ControllerWrapper name={OnboardingFormFields.CITY}>
            {({ value, onBlur, onChange, error }) => (
              <LiliTextInput
                value={value}
                onBlur={() => {
                  onChange(normalizeInputSpacesOnBlur(value));
                  onBlur();
                }}
                onChange={(val) => onChange(normalizeInputSpacesOnChange(val))}
                id={OnboardingFormFields.CITY}
                title={t('pages.homeAddress.cityFieldTitle')}
                errorMessage={error?.message}
                disabled={disabled}
                tabIndex={baseTabIndex + 2}
              />
            )}
          </ControllerWrapper>
        </div>
      </div>
      <div className='flex items-start gap-[14px]  w-full'>
        <div className='w-full '>
          <AddressStateInput disabled={disabled} tabIndex={baseTabIndex + 3} />
        </div>

        <div className='w-full '>
          <ZipInput disabled={disabled} tabIndex={baseTabIndex + 4} />
        </div>
      </div>
    </>
  );
};
